import React from "react";
import MainTemplate from "@/components/Templates/MainTemplate";
import { MedicalPageContent } from "./AppTemplate";

function MedicalesktopTemplate() {
  return (
    <MainTemplate>
      <MedicalPageContent showHeader />
    </MainTemplate>
  );
}

export default MedicalesktopTemplate;
